// components/BankDataForm.js
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../redux/actions/configApi';
import { Form, Button, Alert, Row, Col } from 'react-bootstrap';
import menuLogo from "../assets/imagens/pentalobe.png";
import InputMask from 'react-input-mask';
import {enviarEmailDadosBancarios} from '../redux/actions/emailAvaliacao'
import '../style/home.css'; // Importamos o CSS
import Loader from './loading';
import { useDispatch } from 'react-redux';

const BankDataForm = () => {
    const location = useLocation();
     const dispatch = useDispatch();
    const [bankData, setBankData] = useState({
        bank_name: '',
        account_number: '',
        agency_number: '',
        account_holder_name: '',
        cpf_cnpj: '',
    });
    const [error, setError] = useState(null);
    const [errors, setErrors] = useState(null);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const history = useNavigate();
    const [errors2, setErrors2] = useState({ cpf: '' });
    const [isEditable, setIsEditable] = useState(true);

    const getQueryParams = (search) => {
        return new URLSearchParams(search);
    };
    const queryParams = getQueryParams(location.search);
    const token = queryParams.get("token");
    const handleChange = (e) => {
        setBankData({ ...bankData, [e.target.name]: e.target.value });
    };
    const validateCpf = (value) => {
        const cpfDigits = value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
        if (cpfDigits.length !== 11) {
            return "CPF inválido. Deve conter 11 dígitos.";
        }
        return '';
    };
    const handleCpfChange = (e) => {
        const value = e.target.value;
        setBankData({ ...bankData, [e.target.name]: e.target.value });
        setErrors2({ ...errors2, cpf: validateCpf(value) });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null); // Limpar mensagens anteriores
        setErrors(null);  // Limpar erros anteriores
        setLoading(true)
        const cpfError = validateCpf(bankData['cpf_cnpj']);
        if (cpfError) {
            setErrors2({ cpf: cpfError });
            setLoading(false)
            return;
        }
        try {
            console.log(token, 'token')
            const response = await api.post(`proposals/${token}`, bankData);
            setSuccess(response.data.message);
            setLoading(false)
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // Faz uma rolagem suave até o topo
            });
            setErrors('')
            dispatch(enviarEmailDadosBancarios(token))//precisa enviar um email informando que o cliente colocou os dados bancarios
        } catch (error) {
            setLoading(false)
            setSuccess('')
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // Faz uma rolagem suave até o topo
            });
            if (error.response) {
                // Erros de validação (422) ou de proposta não encontrada (404)
                if (error.response.status === 422) {
                    setErrors(error.response.data.errors); // Erros de validação
                } else if (error.response.status === 404) {
                    setError(error.response.data.message); // Proposta não encontrada
                } else {
                    setError('Ocorreu um erro inesperado.'); // Outros erros
                }
            } else {
                setError('Erro na conexão com o servidor.');
            }
        }
    };

    useEffect(() => {
        const fetchBankData = async () => {
            if (!token) return;
            setLoading(true);
            try {
                const response = await api.get(`proposalsForm/${token}`);
                setBankData((prevData) => ({
                    ...prevData,
                    ...response.data.bankData // Atualiza os valores com os retornados da API
                }));
                setIsEditable(false);
                setLoading(false);
            } catch (err) {
                setError("Erro ao carregar dados bancários.");
                setLoading(false);
            }
        };
        fetchBankData();
    }, [token]);

    return (
        <div className="d-flex justify-content-center align-items-center mt-5">
            <div className={`loading ${loading ? 'loading-active' : ''}`}>
                <Loader loading={loading} />
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col className="d-flex justify-content-center align-items-center m-3 flex-direction-row">
                            <img style={{ width: '150px' }} src={menuLogo} alt="fundo-imagem-home" />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center align-items-center m-3 flex-direction-row">
                            <h3 className='m-3' style={{ fontSize: '1.3em' }}>Cadastrar Dados Bancários</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center align-items-center  flex-direction-column">
                            <div>
                                {error && <Alert variant="danger">{error}</Alert>}
                                {success && <Alert className="text-center" variant="success">{success} <br/> Para mais informações acesse o <a href='/login'>Painel Administrativo</a></Alert>}
                            </div>
                        </Col>
                    </Row>
                    <Form.Group controlId="bank_name">
                        <Form.Label>Nome do Banco</Form.Label>
                        <Form.Control type="text" name="bank_name" value={bankData.bank_name} onChange={handleChange} required />
                        {errors?.bank_name && <p>{errors.bank_name[0]}</p>}
                    </Form.Group>
                    <Form.Group controlId="account_number">
                        <Form.Label>Número da Conta</Form.Label>
                        <Form.Control type="text" name="account_number" value={bankData.account_number} onChange={handleChange} required />
                        {errors?.account_number && <p>{errors.account_number[0]}</p>}
                    </Form.Group>
                    <Form.Group controlId="agency_number">
                        <Form.Label>Número da Agência</Form.Label>
                        <Form.Control type="text" name="agency_number" value={bankData.agency_number} onChange={handleChange} required />
                        {errors?.agency_number && <p>{errors.agency_number[0]}</p>}
                    </Form.Group>
                    <Form.Group controlId="account_holder_name">
                        <Form.Label>Nome do Titular</Form.Label>
                        <Form.Control type="text" name="account_holder_name" readOnly={!isEditable} value={bankData.account_holder_name} onChange={handleChange} required />
                        {errors?.account_holder_name && <p>{errors.account_holder_name[0]}</p>}
                    </Form.Group>
                    <Form.Group controlId="cpf">
                        <Form.Label className='mt-3'>CPF</Form.Label>
                        <InputMask
                            mask="999.999.999-99"
                            name="cpf_cnpj"
                            value={bankData.cpf_cnpj}
                            onChange={handleCpfChange}
                            required
                            readOnly={!isEditable}
                        >
                            {(inputProps) => (
                                <Form.Control
                                    {...inputProps}
                                    type="text"
                                    placeholder="Digite o CPF"
                                    isInvalid={!!errors2?.cpf}
                                    required
                                />
                            )}
                        </InputMask>
                        <Form.Control.Feedback type="invalid">
                            {errors2?.cpf}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Row>
                        <Col className="d-flex justify-content-center align-items-center m-3">
                            <Button variant="primary" type="submit" className='text-center'>
                                {loading ? 'Salvando....' : 'Salvar Dados Bancários'}
                            </Button>

                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    );
};

export default BankDataForm;
